import { MemorySearchSettings } from '../memory-search-client/memory-search-client';

export interface GoToSourceSettings extends MemorySearchSettings {
  type: 'goto';
  allowedGotoItems?: string[];
}
